// Central catalog of data-testid values used across the app.

export const LOGIN = {
  root: "login-page",
  username: "login-username-input",
  password: "login-password-input",
  submit: "login-submit-button",
  error: "login-error-message",
  recoverHint: "login-recover-hint",
};

export const CHANGE_PWD = {
  root: "change-password-page",
  current: "change-password-current-input",
  next: "change-password-new-input",
  confirm: "change-password-confirm-input",
  submit: "change-password-submit-button",
  error: "change-password-error-message",
};

export const SHELL = {
  sidebar: "app-sidebar",
  sidebarBrand: "app-sidebar-brand",
  bottomNav: "app-bottom-nav",
  logout: "app-logout-button",
  userMenu: "app-user-menu-button",
  header: "app-header",
  main: "app-main",
  navDashboard: "nav-dashboard",
  navHoje: "nav-hoje",
  navPedidos: "nav-pedidos",
  navAgenda: "nav-agenda",
  navClientes: "nav-clientes",
  navFornecedores: "nav-fornecedores",
  navNotificacoes: "nav-notificacoes",
  navAdmin: "nav-admin",
  navPerfil: "nav-perfil",
  navAdminUtilizadores: "nav-admin-utilizadores",
  navAdminConfig: "nav-admin-configuracoes",
  navAdminAudit: "nav-admin-audit",
  // Evolução e adoção: o item do operador só existe com
  // `performance_enabled` ligada; "Adoção da equipa" é de admin/gestor e
  // existe também em modo shadow.
  navReconhecimento: "nav-reconhecimento",
  navAdocao: "nav-equipa-adocao",
  // Bloco H2.10 — logo clicável (SPA nav para o Dashboard), um testid por
  // ocorrência (sidebar desktop, header mobile, drawer mobile) porque as
  // três podem coexistir no DOM ao mesmo tempo (o drawer sobrepõe-se ao
  // header, não o substitui).
  // P0.6 — "+ Pedido" no header (modo operador) e ecrã de espera das
  // guardas de encaminhamento enquanto a config não chega.
  newRequest: "shell-new-request-btn",
  routeLoading: "shell-route-loading",
  logoHomeDesktop: "app-logo-home-desktop",
  logoHomeMobileHeader: "app-logo-home-mobile-header",
  logoHomeMobileDrawer: "app-logo-home-mobile-drawer",
};

export const USERS = {
  root: "users-page",
  createBtn: "users-create-button",
  createDialog: "users-create-dialog",
  createName: "users-create-name-input",
  createUsername: "users-create-username-input",
  createRole: "users-create-role-select",
  createPassword: "users-create-password-input",
  createPhone: "users-create-phone-input",
  createCanCreate: "users-create-can-create-checkbox",
  createCanAudit: "users-create-can-audit-checkbox",
  createSubmit: "users-create-submit-button",
  table: "users-table",
  row: (id) => `users-row-${id}`,
  rowEdit: (id) => `users-row-edit-${id}`,
  rowReset: (id) => `users-row-reset-${id}`,
  rowRevoke: (id) => `users-row-revoke-${id}`,
  rowToggleActive: (id) => `users-row-toggle-active-${id}`,
  rowUnlock: (id) => `users-row-unlock-${id}`,
  editDialog: "users-edit-dialog",
  editSubmit: "users-edit-submit-button",
  resetDialog: "users-reset-dialog",
  resetPassword: "users-reset-password-input",
  resetSubmit: "users-reset-submit-button",
};

export const CONFIG = {
  root: "config-page",
  tabPrefs: "config-tab-prefs",
  tabTypes: "config-tab-types",
  tabStates: "config-tab-states",
  gestorAudit: "config-gestor-audit-switch",
  // Escada da camada de evolução: `performance` é o pai, os outros dois não
  // funcionam sozinhos e ficam desativados enquanto ele estiver desligado.
  performance: "config-performance-switch",
  ranking: "config-ranking-switch",
  recognition: "config-recognition-switch",
  flagBlocked: (key) => `config-flag-blocked-${key}`,
  defaultAlert: "config-default-alert-select",
  submit: "config-submit-button",
};

export const TYPES = {
  root: "types-section",
  newBtn: "types-new-button",
  list: "types-list",
  row: (id) => `types-row-${id}`,
  rowUp: (id) => `types-row-up-${id}`,
  rowDown: (id) => `types-row-down-${id}`,
  rowEdit: (id) => `types-row-edit-${id}`,
  rowActive: (id) => `types-row-active-${id}`,
  dialog: "types-dialog",
  dialogName: "types-dialog-name-input",
  dialogSubmit: "types-dialog-submit-button",
};

export const STATES = {
  root: "states-section",
  newBtn: "states-new-button",
  list: "states-list",
  row: (id) => `states-row-${id}`,
  rowUp: (id) => `states-row-up-${id}`,
  rowDown: (id) => `states-row-down-${id}`,
  rowEdit: (id) => `states-row-edit-${id}`,
  rowActive: (id) => `states-row-active-${id}`,
  dialog: "states-dialog",
  dialogName: "states-dialog-name-input",
  dialogBehavior: "states-dialog-behavior-select",
  dialogColor: (hex) => `states-dialog-color-${hex.replace("#", "").toLowerCase()}`,
  dialogSubmit: "states-dialog-submit-button",
};

// Voice recorder (reusable, used in UpdateComposer + PedidoNovo).
// Voz V2.2 — transcrição automática (sem botões "Transcrever"/"Aplicar
// texto"): listening/transcribing/transcribeError substituem os antigos
// transcribeBtn/applyBtn/transcriptionText.
export const VOICE = {
  root: "voice-recorder",
  startBtn: "voice-start-btn",
  stopBtn: "voice-stop-btn",
  cancelBtn: "voice-cancel-btn",
  redoBtn: "voice-redo-btn",
  tooShort: "voice-too-short",
  player: "voice-player",
  timer: "voice-timer",
  listening: "voice-listening",
  starting: "voice-starting",
  uploading: "voice-uploading",
  transcribing: "voice-transcribing",
  transcribeError: "voice-transcribe-error",
  consentDialog: "voice-consent-dialog",
  consentAccept: "voice-consent-accept",
  consentDecline: "voice-consent-decline",
  error: "voice-error",
};

export const AUDIT = {
  root: "audit-page",
  table: "audit-table",
  filterAction: "audit-filter-action",
  filterTarget: "audit-filter-target",
};

// DASH — testids do dashboard legacy (OperadorDashboard/GestorDashboard,
// disponíveis em /dashboards/legacy). Não renomear nem remover: usados
// directamente por esses ficheiros.
export const DASH = {
  root: "dashboard-page",
  operadorRoot: "operador-dashboard",
  gestorRoot: "gestor-dashboard",
  kpi: (name) => `dashboard-kpi-${name}`,
  section: (name) => `dashboard-section-${name}`,
  attentionItem: (id) => `dashboard-attention-${id}`,
  meusItem: (id) => `dashboard-meus-${id}`,
  participoItem: (id) => `dashboard-participo-${id}`,
  periodPicker: "dashboard-period-picker",
  filterState: "dashboard-filter-state",
  filterPriority: "dashboard-filter-priority",
  filterType: "dashboard-filter-type",
  filterResponsible: "dashboard-filter-responsible",
  fromDate: "dashboard-from-date",
  toDate: "dashboard-to-date",

  // Fase 5.5 — dashboard v2 (DashboardShell + subcomponentes em
  // pages/dashboard/). Strings distintas das do dashboard legacy acima
  // (prefixo "dash-" em vez de "dashboard-"), por isso sem colisão.
  v2Root: "dash-root-v2",
  generatedAt: "dash-generated-at",
  refresh: "dash-refresh",
  v2Error: "dash-error",
  dateErrorState: "dash-date-error-state",
  kpiCard: (key) => `dash-kpi-${key}`,
  kpiAvg: "dash-kpi-avg",
  attention: "dash-attention",
  attentionEmpty: "dash-attention-empty",
  attentionSeeAll: "dash-attn-see-all",
  attentionRow: (id) => `dash-attn-row-${id}`,
  attentionCard: (id) => `dash-attn-card-${id}`,
  // H3.19 — paginação server-side de "Requer atenção" (substitui o antigo
  // "Mostrar mais" client-side, removido nesta alteração).
  attentionPageSummary: "dash-attn-page-summary",
  attentionPagePrev: "dash-attn-page-prev",
  attentionPageNext: "dash-attn-page-next",
  timeline: "dash-timeline",
  timelineEmpty: "dash-timeline-empty",
  // Auditoria 2026-10 — âmbito temporal explícito e secções recolhidas.
  kpiScope: (group) => `dash-kpi-scope-${group}`,
  secondary: "dash-secondary",
  distributions: "dash-distributions",
  distributionSingle: (id) => `dash-dist-single-${id}`,
  backToToday: "dash-back-to-today",
  distribution: (id) => `dash-dist-${id}`,
  responsibleTable: "dash-responsible-table",
  workloadRow: (key) => `dash-workload-row-${key}`,
  filterPeriod: "dash-filter-period",
  filterDateFrom: "dash-filter-date-from",
  filterDateTo: "dash-filter-date-to",
  filterDateError: "dash-filter-date-error",
  filterResponsibleV2: "dash-filter-responsible",
  filterTypeV2: "dash-filter-type",
  filterPriorityV2: "dash-filter-priority",
  filterStateV2: "dash-filter-state",
  filterClient: "dash-filter-client",
  filterClear: "dash-filter-clear",
  filterOpen: "dash-filter-open",
  // M2 — faixa compacta de período em mobile (uma linha).
  periodBarMobile: "dash-period-bar-mobile",
  generatedAtMobile: "dash-generated-at-mobile",
  refreshMobile: "dash-refresh-mobile",
};
export const AUDIT_FILTERS = {
  fromDate: "audit-filter-from",
  toDate: "audit-filter-to",
  actor: "audit-filter-actor",
  entity: "audit-filter-entity",
};
export const PEDIDOS = {
  root: "pedidos-page",
  newBtn: "pedidos-new-button",
  search: "pedidos-search-input",
  filterState: "pedidos-filter-state",
  filterType: "pedidos-filter-type",
  filterPriority: "pedidos-filter-priority",
  filterClient: "pedidos-filter-client",
  filterScope: "pedidos-filter-scope",
  onlyOverdue: "pedidos-only-overdue",
  onlyActive: "pedidos-only-active",
  clearFilters: "pedidos-clear-filters",
  tabList: "pedidos-tab-list",
  tabKanban: "pedidos-tab-kanban",
  list: "pedidos-list",
  row: (id) => `pedidos-row-${id}`,
  kanban: "pedidos-kanban",
  kanbanCol: (state) => `pedidos-kanban-col-${state}`,
  kanbanCard: (id) => `pedidos-kanban-card-${id}`,
  kanbanMobileState: "pedidos-kanban-mobile-state",
  pageNext: "pedidos-page-next",
  pagePrev: "pedidos-page-prev",
  activeUrlFilter: "pedidos-active-url-filter",
  activeUrlFilterClear: "pedidos-active-url-filter-clear",
  // H3.12/H3.13 — paginação server-side da Lista + carregamento incremental do Kanban.
  pageSize: "pedidos-page-size",
  pageSummary: "pedidos-page-summary",
  // Auditoria 2026-10 — erro de carregamento da Lista, distinto de "sem resultados".
  loadError: "pedidos-load-error",
  retry: "pedidos-retry",
  kanbanLoadMore: (state) => `pedidos-kanban-load-more-${state}`,
};
// Bloco F1 — módulo Agenda (visualização semanal + pedidos por agendar).
export const AGENDA = {
  root: "agenda-page",
  weekNav: "agenda-week-nav",
  weekPrev: "agenda-week-prev",
  weekToday: "agenda-week-today",
  weekNext: "agenda-week-next",
  weekLabel: "agenda-week-label",
  userFilter: "agenda-user-filter",
  userFilterOption: (id) => `agenda-user-filter-option-${id}`,
  userFilterClear: "agenda-user-filter-clear",
  // M2 — com um único utilizador selecionável não há filtro: só o nome.
  userFilterSingle: "agenda-user-filter-single",
  usersError: "agenda-users-error",
  calendar: "agenda-calendar",
  calendarError: "agenda-calendar-error",
  calendarEmpty: "agenda-calendar-empty",
  calendarLoading: "agenda-calendar-loading",
  dayColumn: (dayKey) => `agenda-day-${dayKey}`,
  event: (segmentKey) => `agenda-event-${segmentKey}`,
  mobileList: "agenda-mobile-list",
  mobileDayGroup: (dayKey) => `agenda-mobile-day-${dayKey}`,
  mobileEventTitle: (segmentKey) => `agenda-mobile-event-title-${segmentKey}`,
  mobileEventMeta: (segmentKey) => `agenda-mobile-event-meta-${segmentKey}`,
  calendarRetry: "agenda-calendar-retry",
  unscheduledRoot: "agenda-unscheduled",
  unscheduledToggle: "agenda-unscheduled-toggle",
  unscheduledCount: "agenda-unscheduled-count",
  unscheduledList: "agenda-unscheduled-list",
  unscheduledItem: (id) => `agenda-unscheduled-item-${id}`,
  unscheduledError: "agenda-unscheduled-error",
  unscheduledEmpty: "agenda-unscheduled-empty",
  unscheduledLoading: "agenda-unscheduled-loading",
  unscheduledMore: "agenda-unscheduled-more",
  unscheduledSchedule: (id) => `agenda-unscheduled-schedule-${id}`,
  unscheduledStateFilter: "agenda-unscheduled-state-filter",

  // Bloco F2 — operações por modal (criar/editar/cancelar). H3.16: "Reagendar"
  // removido por duplicar exatamente o fluxo de "Editar".
  eventDetail: "agenda-event-detail",
  eventDetailCode: "agenda-event-detail-code",
  eventDetailPriority: "agenda-event-detail-priority",
  eventDetailAssignees: "agenda-event-detail-assignees",
  eventDetailCompleted: "agenda-event-detail-completed",
  eventDetailViewRequest: "agenda-event-detail-view-request",
  eventDetailEdit: "agenda-event-detail-edit",
  eventDetailCancel: "agenda-event-detail-cancel",
  eventDetailClose: "agenda-event-detail-close",

  scheduleModal: "agenda-schedule-modal",
  scheduleModalCode: "agenda-schedule-modal-code",
  scheduleModalClient: "agenda-schedule-modal-client",
  scheduleModalAddress: "agenda-schedule-modal-address",
  scheduleModalResponsible: "agenda-schedule-modal-responsible",
  scheduleModalParticipants: "agenda-schedule-modal-participants",
  scheduleModalDeadline: "agenda-schedule-modal-deadline",
  scheduleModalState: "agenda-schedule-modal-state",
  scheduleModalStartAt: "agenda-schedule-modal-start-at",
  scheduleModalEndAt: "agenda-schedule-modal-end-at",
  scheduleModalDuration: (key) => `agenda-schedule-modal-duration-${key}`,
  scheduleModalNotes: "agenda-schedule-modal-notes",
  scheduleModalAssignees: "agenda-schedule-modal-assignees",
  scheduleModalAssignee: (id) => `agenda-schedule-modal-assignee-${id}`,
  scheduleModalError: "agenda-schedule-modal-error",
  scheduleModalCancel: "agenda-schedule-modal-cancel",
  scheduleModalSubmit: "agenda-schedule-modal-submit",

  warningDialog: "agenda-warning-dialog",
  warningConflictItem: (scheduleId) => `agenda-warning-conflict-${scheduleId}`,
  warningDeadlineItem: "agenda-warning-deadline",
  warningBack: "agenda-warning-back",
  warningConfirm: "agenda-warning-confirm",

  cancelDialog: "agenda-cancel-dialog",
  cancelReason: "agenda-cancel-reason",
  cancelError: "agenda-cancel-error",
  cancelBack: "agenda-cancel-back",
  cancelConfirm: "agenda-cancel-confirm",

  // Bloco H2.5 — legenda de cores por utilizador.
  userColorLegend: "agenda-user-color-legend",
  userColorLegendItem: (id) => `agenda-user-color-legend-item-${id}`,

  // P0.7 — Agenda do operador: lista cronológica agrupada por dia, em vez da
  // grelha semanal. Prefixo próprio (`agenda-operator-…`) para nenhum teste
  // da Agenda de gestão poder apanhar estes elementos por engano.
  operatorList: "agenda-operator-list",
  operatorDay: (dayKey) => `agenda-operator-day-${dayKey}`,
  operatorDayHeading: (dayKey) => `agenda-operator-day-heading-${dayKey}`,
  operatorItem: (key) => `agenda-operator-item-${key}`,
  operatorEmpty: "agenda-operator-empty",
  operatorEmptyRequests: "agenda-operator-empty-requests",
  operatorLoading: "agenda-operator-loading",
  operatorError: "agenda-operator-error",
  operatorRetry: "agenda-operator-retry",
  operatorItemTeam: (key) => `agenda-operator-item-team-${key}`,
  operatorItemCompleted: (key) => `agenda-operator-item-completed-${key}`,
};

export const CLIENTES = {
  root: "clientes-page",
  search: "clientes-search",
  novo: "clientes-novo",
  table: "clientes-table",
  row: (id) => `clientes-row-${id}`,
  // Paginação server-side (bloco escalabilidade)
  pageSize: "clientes-page-size",
  pagePrev: "clientes-page-prev",
  pageNext: "clientes-page-next",
  pageSummary: "clientes-page-summary",
  empty: "clientes-empty",
  loadError: "clientes-load-error",
  // Dialog criar/editar cliente
  dialog: "cliente-dialog",
  legalName: "cliente-legal-name",
  abbreviation: "cliente-abbreviation",
  taxId: "cliente-tax-id",
  isActive: "cliente-is-active",
  save: "cliente-save",
  cancel: "cliente-cancel",
  error: "cliente-error",
  // Detalhe
  detailRoot: "cliente-detalhe-page",
  back: "cliente-detalhe-back",
  edit: "cliente-detalhe-edit",
  toggleActive: "cliente-detalhe-toggle-active",
  addAddress: "cliente-add-address",
  addressRow: (id) => `cliente-address-row-${id}`,
  addressLabel: "address-label",
  addressAddress: "address-address",
  addressPostal: "address-postal",
  addressCity: "address-city",
  // P0.8 — campo do telefone do local, no diálogo de morada.
  addressPhone: "address-phone",
  addressDefault: "address-default",
  addressSave: "address-save",
  addressCancel: "address-cancel",
  addressSetDefault: (id) => `address-set-default-${id}`,
  addressToggleActive: (id) => `address-toggle-active-${id}`,
  addressEdit: (id) => `address-edit-${id}`,
  addressCall: (id) => `address-call-${id}`,
};

export const FORNECEDORES = {
  root: "fornecedores-page",
  search: "fornecedores-search",
  novo: "fornecedores-novo",
  table: "fornecedores-table",
  row: (id) => `fornecedores-row-${id}`,
  edit: (id) => `fornecedor-edit-${id}`,
  toggleActive: (id) => `fornecedor-toggle-active-${id}`,
  // Paginação server-side (bloco escalabilidade)
  pageSize: "fornecedores-page-size",
  pagePrev: "fornecedores-page-prev",
  pageNext: "fornecedores-page-next",
  pageSummary: "fornecedores-page-summary",
  empty: "fornecedores-empty",
  loadError: "fornecedores-load-error",
  // Dialog criar/editar
  dialog: "fornecedor-dialog",
  name: "fornecedor-name",
  abbreviation: "fornecedor-abbreviation",
  taxId: "fornecedor-tax-id",
  phone: "fornecedor-phone",
  email: "fornecedor-email",
  contact: "fornecedor-contact",
  notes: "fornecedor-notes",
  save: "fornecedor-save",
  cancel: "fornecedor-cancel",
  error: "fornecedor-error",
};

export const SUPPLIER_SELECT = {
  root: "supplier-select",
  trigger: "supplier-select-trigger",
  search: "supplier-select-search",
  option: (id) => `supplier-select-option-${id}`,
  notFound: "supplier-select-not-found",
  goToSuppliers: "supplier-select-go-to-suppliers",
  loading: "supplier-select-loading",
  empty: "supplier-select-empty",
  loadError: "supplier-select-load-error",
  retry: "supplier-select-retry",
};

export const CLIENT_SELECT = {
  root: "client-select",
  trigger: "client-select-trigger",
  search: "client-select-search",
  option: (id) => `client-select-option-${id}`,
  clear: "client-select-clear",
  address: "client-select-address",
  addressOption: (id) => `client-select-address-${id}`,
  loading: "client-select-loading",
  empty: "client-select-empty",
};

export const PEDIDO_NOVO = {
  root: "pedido-novo-page",
  backLink: "pedido-novo-back-link",
  title: "pedido-novo-title",
  description: "pedido-novo-description",
  type: "pedido-novo-type",
  priority: "pedido-novo-priority",
  responsible: "pedido-novo-responsible",
  responsibleSelf: "pedido-novo-responsible-self",
  deadline: "pedido-novo-deadline",
  lembreteAt: "pedido-novo-lembrete-at",
  client: "pedido-novo-client",
  participantsToggle: "pedido-novo-participants-toggle",
  participant: (id) => `pedido-novo-participant-${id}`,
  situation: "pedido-novo-situation",
  alertHours: "pedido-novo-alert-hours",
  step1Next: "pedido-novo-step1-next",
  createNow: "pedido-novo-create-now",
  addDetails: "pedido-novo-add-details",
  submit: "pedido-novo-submit",
  step2Back: "pedido-novo-step2-back",
  cancel: "pedido-novo-cancel",
  error: "pedido-novo-error",
  photos: "pedido-novo-photos",
  // Voz V2 — interpretação automática do pedido a partir da transcrição.
  voiceInterpreting: "pedido-novo-voice-interpreting",
  voiceInterpretError: "pedido-novo-voice-interpret-error",
  voiceFilledBadge: (field) => `pedido-novo-voice-filled-${field}`,
  ambiguity: (field) => `pedido-novo-ambiguity-${field}`,
  ambiguityCandidate: (field, id) => `pedido-novo-ambiguity-${field}-${id}`,
  ambiguityDismiss: (field) => `pedido-novo-ambiguity-dismiss-${field}`,
};
export const PEDIDO_DETALHE = {
  root: "pedido-detalhe-page",
  title: "pedido-detalhe-title",
  code: "pedido-detalhe-code",
  state: "pedido-detalhe-state",
  situation: "pedido-detalhe-situation",
  deadline: "pedido-detalhe-deadline",
  responsible: "pedido-detalhe-responsible",
  priority: "pedido-detalhe-priority",
  type: "pedido-detalhe-type",
  client: "pedido-detalhe-client",
  toggleDetails: "pedido-detalhe-toggle-details",
  newUpdateBtn: "pedido-detalhe-new-update-btn",
  changeStateBtn: "pedido-detalhe-change-state-btn",
  editBtn: "pedido-detalhe-edit-btn",
  breadcrumb: "pedido-detalhe-breadcrumb",
  adminChanges: "pedido-detalhe-admin-changes",
  adminChangeEntry: (id) => `pedido-detalhe-admin-change-${id}`,
  timeline: "pedido-detalhe-timeline",
  timelineEntry: (id) => `pedido-detalhe-timeline-${id}`,
  timelineCorrect: (id) => `pedido-detalhe-timeline-correct-${id}`,
  timelineCorrects: (id) => `pedido-detalhe-timeline-corrects-${id}`,
  composer: "pedido-detalhe-update-composer",
  composerText: "pedido-detalhe-update-text",
  composerAttach: "pedido-detalhe-update-attach",
  composerSubmit: "pedido-detalhe-update-submit",
  composerCancel: "pedido-detalhe-update-cancel",
  composerMoreOptions: "pedido-detalhe-update-more-options",
  // Auditoria 2026-10 — acções de estado contextuais no modo de gestão.
  stateActionBtn: (to) => `pedido-detalhe-state-action-${to}`,
  stateDialog:"pedido-detalhe-state-dialog",
  stateDialogTo: "pedido-detalhe-state-dialog-to",
  stateDialogJustification: "pedido-detalhe-state-dialog-justification",
  stateDialogSubmit: "pedido-detalhe-state-dialog-submit",
  planningBadge: "pedido-detalhe-planning-badge",
  scheduleBtn: "pedido-detalhe-schedule-btn",
  planningSummary: "pedido-detalhe-planning-summary",
  planningSummaryItem: (id) => `pedido-detalhe-planning-summary-item-${id}`,
  planningSummaryCompleted: (id) => `pedido-detalhe-planning-summary-completed-${id}`,
  planningSummaryEdit: (id) => `pedido-detalhe-planning-summary-edit-${id}`,
  planningSummaryCancel: (id) => `pedido-detalhe-planning-summary-cancel-${id}`,
  planningSummaryEmpty: "pedido-detalhe-planning-summary-empty",
  adminChangesToggle: "pedido-detalhe-admin-changes-toggle",
  // H3.6 / PED-04 — confirmação de conclusão com agendamentos futuros ativos.
  completionScheduleWarningDialog: "pedido-detalhe-completion-schedule-warning-dialog",
  completionScheduleWarningItem: (id) => `pedido-detalhe-completion-schedule-warning-item-${id}`,
  completionScheduleWarningBack: "pedido-detalhe-completion-schedule-warning-back",
  completionScheduleWarningConfirm: "pedido-detalhe-completion-schedule-warning-confirm",
  // AUD-007 — estados terminais explícitos quando load() falha (nunca fica
  // preso no spinner). notFound=404, forbidden=403, loadError=outros erros.
  notFound: "pedido-detalhe-not-found",
  forbidden: "pedido-detalhe-forbidden",
  loadError: "pedido-detalhe-load-error",
  loadErrorRetry: "pedido-detalhe-load-error-retry",
  backToList: "pedido-detalhe-back-to-list",
};
// Fase 5.4 — centralização dos testids de EditRequestDialog (antes strings soltas).
export const EDIT_REQUEST = {
  dialog: "edit-request-dialog",
  title: "edit-request-title",
  description: "edit-request-description",
  type: "edit-request-type",
  priority: "edit-request-priority",
  client: "edit-request-client",
  responsible: "edit-request-responsible",
  deadline: "edit-request-deadline",
  lembreteAt: "edit-request-lembrete-at",
  participant: (id) => `edit-request-participant-${id}`,
  error: "edit-request-error",
  save: "edit-request-save",
  cancel: "edit-request-cancel",
  confirmPanel: "edit-request-confirm-panel",
  confirmBack: "edit-request-confirm-back",
  confirmSave: "edit-request-confirm-save",
};
export const NOTIFS = {
  root: "notifications-page",
  tabAll: "notifications-tab-all",
  tabUnread: "notifications-tab-unread",
  filterKind: "notifications-filter-kind",
  markAllRead: "notifications-mark-all-read",
  item: (id) => `notifications-item-${id}`,
};
export const PROFILE = {
  root: "profile-page",
  adminSection: "profile-admin-section",
  linkUtilizadores: "profile-link-utilizadores",
  linkConfiguracoes: "profile-link-configuracoes",
  linkAuditLog: "profile-link-audit-log",
  linkLaboratorio: "profile-link-laboratorio",
};
// AUD-003 — Error Boundary global (src/components/ErrorBoundary.jsx).
export const ERROR_BOUNDARY = {
  root: "error-boundary-fallback",
  retry: "error-boundary-retry",
  reload: "error-boundary-reload",
};
// Guarda global de alterações não guardadas (src/context/UnsavedChangesContext.jsx).
export const UNSAVED_CHANGES = {
  dialog: "unsaved-changes-dialog",
  confirm: "unsaved-changes-confirm",
  cancel: "unsaved-changes-cancel",
};
// P0.4 — Home "Hoje" do operador (src/pages/Hoje.jsx) e cartão de serviço
// reutilizável (src/components/service/ServiceCard.jsx).
export const HOJE = {
  root: "hoje-page",
  routeLoading: "hoje-route-loading",
  skeleton: "hoje-skeleton",
  offlineBanner: "hoje-offline-banner",
  multipleInProgress: "hoje-multiple-in-progress",
  sectionToday: "hoje-section-today",
  sectionNext: "hoje-section-next",
  sectionOverdue: "hoje-section-overdue",
  sectionWaiting: "hoje-section-waiting",
  // Auditoria 2026-10 — "O meu dia": resumo curto e grupo "Precisam de ação".
  summary: "hoje-summary",
  summaryItem: (key) => `hoje-summary-${key}`,
  sectionNeedsAction: "hoje-section-needs-action",
  sectionWaitingDue: "hoje-section-waiting-due",
  linkIndicators: "hoje-link-indicators",
  overdueCount: "hoje-overdue-count",
  waitingSeeAll: "hoje-waiting-see-all",
  emptyToday: "hoje-empty-today",
  emptyAll: "hoje-empty-all",
  linkPedidos: "hoje-link-pedidos",
  linkNovoPedido: "hoje-link-novo-pedido",
  error: (section) => `hoje-error-${section}`,
  retry: (section) => `hoje-retry-${section}`,
};
// P0.5 — detalhe do serviço no modo operador.
export const SERVICE_HEADER = {
  root: "service-header",
  address: "service-header-address",
  team: "service-header-team",
  navigate: "service-header-navigate",
  // P0.8 — só existe quando a morada da intervenção tem telefone.
  call: "service-header-call",
};
export const STATE_ACTION = {
  bar: "state-action-bar",
  primary: "state-action-primary",
  secondary: "state-action-secondary",
  cancel: "state-action-cancel",
  managedBy: "state-action-managed-by",
  closed: "state-action-closed",
  sheet: "state-action-sheet",
  sheetTitle: "state-action-sheet-title",
};
export const SERVICE_DETAIL = {
  historyToggle: "service-history-toggle",
};
export const QUICK_ACTIONS = {
  root: "quick-actions",
  photo: "quick-action-photo",
  voice: "quick-action-voice",
  note: "quick-action-note",
};
export const SERVICE_CARD = {
  primary: "service-card-primary",
  compact: "service-card-compact",
  open: "service-card-open",
  action: "service-card-action",
  navigate: "service-card-navigate",
  call: "service-card-call",
  stateManagedBy: "service-card-state-managed-by",
  startedAt: "service-card-started-at",
  lateToStart: "service-card-late-to-start",
};

// Galeria de fotografias no detalhe do pedido.
export const PHOTO_GALLERY = {
  root: "photo-gallery",
  count: "photo-gallery-count",
  add: "photo-gallery-add",
  uploader: "photo-gallery-uploader",
  save: "photo-gallery-save",
  cancel: "photo-gallery-cancel",
  item: (fileId) => `photo-gallery-item-${fileId}`,
  remove: (fileId) => `photo-gallery-remove-${fileId}`,
  removeDialog: "photo-gallery-remove-dialog",
  removeConfirm: "photo-gallery-remove-confirm",
  error: "photo-gallery-error",
  retry: "photo-gallery-retry",
};

// Confirmação de guardar com envios de ficheiros por terminar.
export const PENDING_UPLOADS = {
  dialog: "pending-uploads-dialog",
  cancel: "pending-uploads-cancel",
  confirm: "pending-uploads-confirm",
  wait: "pending-uploads-wait",
};

// Anexos — miniatura na Timeline e pré-visualização in-app de imagens.
export const ATTACHMENT = {
  // Cartão/miniatura na Timeline
  card: (fileId) => `attachment-card-${fileId}`,
  thumb: (fileId) => `attachment-thumb-${fileId}`,
  thumbFallback: (fileId) => `attachment-thumb-fallback-${fileId}`,
  chip: (fileId) => `attachment-chip-${fileId}`,
  grid: "attachment-grid",
  removed: "attachment-removed",
  // Pré-visualização
  preview: "attachment-preview",
  previewImage: "attachment-preview-image",
  previewLoading: "attachment-preview-loading",
  previewError: "attachment-preview-error",
  previewRetry: "attachment-preview-retry",
  previewDownload: "attachment-preview-download",
  previewClose: "attachment-preview-close",
  previewFilename: "attachment-preview-filename",
};

// Reconhecimento e adoção — página do operador.
export const RECOGNITION = {
  root: "recognition-page",
  routeLoading: "recognition-route-loading",
  skeleton: "recognition-skeleton",
  error: "recognition-error",
  retry: "recognition-retry",
  periodToggle: "recognition-period-toggle",
  periodOption: (kind) => `recognition-period-${kind}`,
  scoreBlock: "recognition-score",
  scoreValue: "recognition-score-value",
  scoreBand: "recognition-score-band",
  scoreRequests: "recognition-score-requests",
  scoreTrend: "recognition-score-trend",
  empty: "recognition-empty",
  breakdown: "recognition-breakdown",
  dimension: (key) => `recognition-dimension-${key}`,
  dimensionValue: (key) => `recognition-dimension-value-${key}`,
  chart: "recognition-chart",
  chartEmpty: "recognition-chart-empty",
  ranking: "recognition-ranking",
  rankingTop: "recognition-ranking-top",
  rankingRow: (position) => `recognition-ranking-row-${position}`,
  rankingMe: "recognition-ranking-me",
  rankingNotice: "recognition-ranking-notice",
  badges: "recognition-badges",
  badge: (key) => `recognition-badge-${key}`,
  badgesEmpty: "recognition-badges-empty",
  basis: "recognition-basis",
  openRequests: "recognition-open-requests",
  settledScore: "recognition-settled-score",
  badgeProgress: "recognition-badge-progress",
  badgeProgressRow: (key) => `recognition-badge-progress-${key}`,
};

// "A minha evolução" — página do operador (`/evolucao`). Substitui a página de
// reconhecimento: mesma leitura, ordem pensada para telemóvel e linguagem de
// adoção em vez de desempenho.
export const EVOLUCAO = {
  root: "evolucao-page",
  skeleton: "evolucao-skeleton",
  error: "evolucao-error",
  retry: "evolucao-retry",
  // A — selector de período
  periodToggle: "evolucao-period-toggle",
  periodOption: (kind) => `evolucao-period-${kind}`,
  periodRange: "evolucao-period-range",
  // B — o meu resultado (único bloco com o número em destaque)
  result: "evolucao-result",
  score: "evolucao-score",
  basis: "evolucao-basis",
  position: "evolucao-position",
  teamScore: "evolucao-team-score",
  delta: "evolucao-delta",
  empty: "evolucao-empty",
  // Uma razão, nunca duas: ou falta amostra ao próprio, ou faltam classificados
  // na equipa (ver `eligibilityNotice`).
  eligibility: "evolucao-eligibility",
  // C — onde posso melhorar. Só rótulo e pontos; as explicações vivem no detalhe.
  improve: "evolucao-improve",
  improveItem: (key) => `evolucao-improve-${key}`,
  // D — detalhe do resultado, fechado por omissão
  detailToggle: "evolucao-detail-toggle",
  detail: "evolucao-detail",
  components: "evolucao-components",
  component: (key) => `evolucao-component-${key}`,
  componentScore: (key) => `evolucao-component-score-${key}`,
  componentWeight: (key) => `evolucao-component-weight-${key}`,
  componentCriteria: (key) => `evolucao-component-criteria-${key}`,
  evaluatedUsers: "evolucao-evaluated-users",
  // Segundo nível de expansão, dentro do detalhe.
  howItWorks: "evolucao-how-it-works",
  howItWorksToggle: "evolucao-how-it-works-toggle",
  // E — classificação, fechada por omissão
  rankingToggle: "evolucao-ranking-toggle",
  rankingSummary: "evolucao-ranking-summary",
  ranking: "evolucao-ranking",
  // Indexada pelo utilizador, não pela posição: empates reais mantêm a mesma
  // posição (1, 2, 2, 4) e duas linhas não podem partilhar o mesmo testid.
  rankingRow: (userId) => `evolucao-ranking-row-${userId}`,
  rankingMe: "evolucao-ranking-me",
  // F — conquistas, fechadas por omissão. Uma linha por conquista, obtidas e em
  // progresso na mesma lista: é o mesmo assunto e separá-las obrigava a ler
  // duas vezes. Zero descrições na lista — as regras vivem em `badgeRules`.
  badgesToggle: "evolucao-badges-toggle",
  badgesSummary: "evolucao-badges-summary",
  badges: "evolucao-badges",
  badge: (key) => `evolucao-badge-${key}`,
  badgeStatus: (key) => `evolucao-badge-status-${key}`,
  badgesEmpty: "evolucao-badges-empty",
  badgeRulesToggle: "evolucao-badge-rules-toggle",
  badgeRules: "evolucao-badge-rules",
};

// Bloco compacto do reconhecimento na Home "Hoje".
export const HOJE_RECOGNITION = {
  root: "hoje-recognition",
  basis: "hoje-recognition-basis",
  score: "hoje-recognition-score",
  position: "hoje-recognition-position",
  link: "hoje-recognition-link",
};

// Área "Equipa → Adoção" (admin/gestor), disponível em modo shadow.
export const ADOCAO = {
  root: "adocao-page",
  skeleton: "adocao-skeleton",
  error: "adocao-error",
  retry: "adocao-retry",
  shadowNotice: "adocao-shadow-notice",
  basis: "adocao-basis",
  dataQuality: "adocao-data-quality",
  coverage: "adocao-coverage",
  coverageWarning: "adocao-coverage-warning",
  coverageReason: (status) => `adocao-coverage-reason-${status}`,
  rewardPolicy: "adocao-reward-policy",
  diagnostics: "adocao-diagnostics",
  diagnosticsToggle: "adocao-diagnostics-toggle",
  periodSelect: "adocao-period-select",
  periodOption: (key) => `adocao-period-${key}`,
  monthSelect: "adocao-month-select",
  kpi: (key) => `adocao-kpi-${key}`,
  table: "adocao-table",
  row: (userId) => `adocao-row-${userId}`,
  rowScore: (userId) => `adocao-row-score-${userId}`,
  rowSettled: (userId) => `adocao-row-settled-${userId}`,
  rowComparison: (userId) => `adocao-row-comparison-${userId}`,
  rowDimension: (userId, key) => `adocao-row-${userId}-${key}`,
  rowDetail: (userId) => `adocao-row-detail-${userId}`,
  // Telemóvel: a tabela de 12 colunas não se lê num ecrã de 390px, por isso as
  // mesmas linhas saem também como cartões. Testids próprios porque as duas
  // vistas coexistem no DOM — é o CSS que escolhe qual se vê, não o React.
  cards: "adocao-cards",
  card: (userId) => `adocao-card-${userId}`,
  cardCell: (userId, key) => `adocao-card-cell-${userId}-${key}`,
  cardDetail: (userId) => `adocao-card-detail-${userId}`,
  empty: "adocao-empty",
  emptyMonth: "adocao-empty-month",
  detailDialog: "adocao-detail-dialog",
  detailHorizons: "adocao-detail-horizons",
  detailRequest: (requestId) => `adocao-detail-request-${requestId}`,
  detailSettled: (requestId) => `adocao-detail-settled-${requestId}`,
  detailSettledEmpty: "adocao-detail-settled-empty",
  detailCriterion: (code) => `adocao-detail-criterion-${code}`,
  // Justificação de um N/A: linha própria, abaixo do critério. Nunca ao lado —
  // são frases inteiras e em telemóvel não cabem numa coluna.
  detailCriterionReason: (code) => `adocao-detail-criterion-reason-${code}`,
};
